import React from 'react'
import { Routes, Route } from 'react-router-dom'
import { GlobalStyles } from '@popety-io/ui'
import HomePage from './pages/HomePage'
import PublicEstimatePage from './pages/estimate/PublicEstimatePage'
import PublicLandAnalysisPage from './pages/land-analysis/PublicLandAnalysisPage'
import PublicBuildingAnalysisPage from './pages/building-analysis/PublicBuildingAnalysisPage'
import NotFoundPage from './pages/NotFoundPage'
import '../i18n' // Initialize i18n

function App() {
  return (
    <>
      <GlobalStyles />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/estimate/:hash" element={<PublicEstimatePage />} />
        <Route
          path="/land-analysis/:publicId"
          element={<PublicLandAnalysisPage />}
        />
        <Route
          path="/land-grouping/:publicId"
          element={<PublicLandAnalysisPage isGrouping />}
        />
        <Route
          path="/building-analysis/:publicId"
          element={<PublicBuildingAnalysisPage />}
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </>
  )
}

export default App
